<template>
    <div id="center_main" class="ui centered container">
        <div class="ui segment">
            <div class="ui text menu">
                <div class="right menu">
                    <div class="item">
                        <div v-if="isHeader" class="ui orange small button" @click="calculate()">정산</div>
                    </div>
                    <div class="item">
                        <div v-if="isHeader" class="ui primary small button" @click="registerCenter()">센터 등록</div>
                    </div>
                </div>
            </div>
            <table class="ui selectable very basic table">
                <thead>
                    <tr>
                        <th class="collapsing">#</th>
                        <th>센터명</th>
                        <th>담당지역</th>
                        <th>전화번호</th>
                        <th>배송기사</th>
                        <th>창고관리자</th>
                        <th>설명</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(center, index) in getCenters()" :key="center._id">
                        <td class="collapsing">{{ index+1 }}</td>
                        <td>{{ center.name }}</td>
                        <td>{{ (center.regions) ? Object.keys(center.regions).join() : "" }}</td>
                        <td>{{ center.phone }}</td>
                        <td>{{ (center.workers) ? getWorkerCount(center.workers, "배송기사") : 0 }}명</td>
                        <td>{{ (center.workers) ? getWorkerCount(center.workers, "창고관리자") : 0 }}명</td>
                        <td>{{ center.description }}</td>
                        <td class="right collapsing">
                            <button class="ui small basic button" @click="openWorkerList(center)">직원</button>
                        </td>
                        <td class="right collapsing">
                            <div class="ui small basic icon buttons">
                                <button class="ui button" @click="editCenter(center)" :disabled="!isHeader">
                                    <i class="edit icon"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    created: function() {
        this.updateCenterList();
    },
    methods: {
        updateCenterList() {
            this.$event.call("openLoading");
            this.$api.getCenters((resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.centers = resData.centers;
                    this.workers = resData.workers;
                    this.products = resData.products;
                }
            });
        },
        openWorkerList(center) { this.$event.call("openWorkerList", center, this.onCenterChange); },
        calculate() { this.$event.call("centerCalculate_open"); },
        registerCenter() { this.$event.call("registerCenter", this.onCenterChange); },
        editCenter(center) { this.$event.call("editCenter", center, this.onCenterChange); },
        onCenterChange() { this.updateCenterList(); },
        getWorkerCount(workerIds, position) 
        {
            let count = 0;
            for (const _workerId of workerIds)
            {
                for (const worker of this.workers)
                {
                    if (worker._id == _workerId && worker.position == position)
                    {
                        count += 1;
                    }
                }
            }
            return count;
        },
        getCenters()
        {
            const array = [];
            for (const center of this.centers)
            {
                if (!center.isTerminated) array.push(center);
            }
            return array;
        }
    },
    computed: {
        user: function() { return this.$store.getters.user; },
        isHeader: function() { return this.$store.getters.isHeader; },
        centers: {
            get: function() { return this.$store.getters.centers; },
            set: function(val) { this.$store.commit("setCenters", val); },
        },
        workers: {
            get: function() { return this.$store.getters.workers; },
            set: function(val) { return this.$store.commit("setWorkers", val); },
        },
        products: {
            get: function() { return this.$store.getters.products; },
            set: function(val) { this.$store.commit("setProducts", val); },
        },
    },
}
</script>

<style>
#center_main {
    margin-top:15px;
}
#center_main .segment {
    min-width:800px;
    min-height: 800px;
}
#center_main .ui.text.menu {
    margin: 0;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/CenterMain.vue